import React from "react"

export function ReferenceCard({
  title,
  intro,
  children,
}: {
  title: string
  intro: string
  children: React.ReactNode
}) {
  return (
    <div className="rounded-lg border border-palette-jungleGreen200 bg-white shadow-sm">
      <div className="border-b border-palette-jungleGreen200 px-6 py-4">
        <h2 className="text-lg font-semibold text-palette-jungleGreen900">{title}</h2>
        <p className="mt-1 text-sm text-palette-jungleGreen500">{intro}</p>
      </div>

      <div className="space-y-8 px-6 py-6">{children}</div>
    </div>
  )
}

export function ReferenceSection({
  title,
  intro,
  children,
}: {
  title: string
  intro?: string
  children: React.ReactNode
}) {
  return (
    <section className="space-y-3">
      <div>
        <h3 className="border-b border-palette-jungleGreen100 pb-2 text-base font-semibold text-palette-jungleGreen900">
          {title}
        </h3>
        {intro && <p className="mt-2 text-sm text-palette-jungleGreen500">{intro}</p>}
      </div>
      {children}
    </section>
  )
}
